import OneTimeWirePage from "components/pages/OneTimeWirePage";

/**
 * @name CaptureOneTimeWireDefault
 * @returns {React.Component}
 * @description 
 */
export default function CaptureOneTimeWireDefault(props) {
    return <OneTimeWirePage />;
}